import { conversasHub } from '../ConversasHub'

export const ConversasMixin = {
    props: {
        usuarioId: { type: String, required: true },
        usuario: { type: String, required: true }
    },

    data() {
        return {
            conversaAtiva: null,
            conversas: [],
            carregando: false,
            participantes: [],
            itensPorPagina: 10,
            _eventosRegistrados: false
        }
    },

    beforeDestroy() {
        this.desconectarEventosHub()
    },

    methods: {
        async inicializarConexaoHub() {
            if (conversasHub.isConnected) {
                this.conectarEventosHub()
                return
            }

            // Só conecta se não estiver conectado
            const fornecedorId = this.$store.getters.fornecedor?.fornecedorId || null
            await conversasHub.conectar(this.usuarioId, fornecedorId)
            this.conectarEventosHub()
        },

        async abrirConversa(item) {
            if (!item?.id) return

            try {
                this.conversaAtiva = item
                this.carregarParticipantes(item)
                this.$bvModal.show(this.modalId)
            } catch (error) {
                console.error('Erro ao abrir conversa:', error)
            }
        },

        carregarParticipantes(conversa) {
            // Se o usuário tem fornecedorId válido, não mostra participantes
            const fornecedorId = this.$store.getters.fornecedor?.fornecedorId
            if (fornecedorId && fornecedorId !== null && fornecedorId !== undefined && fornecedorId !== '') {
                this.participantes = []
                return
            }

            this.participantes = []
            
            if (!conversa) return

            const participantesMap = new Map()
            
            if (conversa.destinatarios && Array.isArray(conversa.destinatarios)) {
                conversa.destinatarios.forEach(destinatario => {
                    if (destinatario.fornecedorId && destinatario.razaoSocial) {
                        participantesMap.set(destinatario.fornecedorId, {
                            id: destinatario.fornecedorId,
                            nome: destinatario.razaoSocial,
                            tipo: 'fornecedor'
                        })
                    }
                })
            }

            if (conversa.usuarioEmAtendimento && conversa.usuarioEmAtendimentoId) {
                participantesMap.set(conversa.usuarioEmAtendimentoId, {
                    id: conversa.usuarioEmAtendimentoId,
                    nome: conversa.usuarioEmAtendimento,
                    tipo: 'usuario'
                })
            }

            this.participantes = Array.from(participantesMap.values())
                .sort((a, b) => a.nome.localeCompare(b.nome))
        },

        fecharConversa() {
            if (this.conversaAtiva && this.conversaAtiva.qtdNaoLidas > 0) {
                const conversa = this.conversas.find(c => c.id === this.conversaAtiva.id)
                if (conversa) {
                    this.$set(conversa, 'qtdNaoLidas', 0)
                }
                this.$forceUpdate()
            }
            
            this.conversaAtiva = null
            this.participantes = []
            
            setTimeout(() => {
                this.carregarConversas()
            }, 500)
        },

        formatarData(data) {
            if (!data) return ''
            return new Date(data).toLocaleString()
        },

        atualizarContadorNovasMensagens() {
            if (this.conversaAtiva) {
                this.carregarConversas()
            }
        },

        onNovaConversaRecebida(novaConversa) {            
            const conversaProcessada = this.processarConversas([novaConversa])[0]
            
            if (conversaProcessada) {
                let deveIncluir = false
                
                if (this.modalId === 'modal-conversa') {
                    deveIncluir = conversaProcessada.usuarioCriacaoId !== this.usuarioId
                } else if (this.modalId === 'modal-conversa-enviada') {
                    deveIncluir = conversaProcessada.usuarioCriacaoId === this.usuarioId
                } else {
                    deveIncluir = true
                }
                
                if (deveIncluir) {
                    const existeIndex = this.conversas.findIndex(c => c.id === conversaProcessada.id)
                    
                    if (existeIndex >= 0) {
                        this.$set(this.conversas, existeIndex, conversaProcessada)
                    } else {
                        this.conversas.unshift(conversaProcessada)
                    }
                    
                    if (typeof this.calcularTotalNaoLidas === 'function') {
                        this.calcularTotalNaoLidas()
                    }
                    
                    this.$forceUpdate()
                }
            }
        },

        async carregarConversas() {
            if (this.carregando) {
                return
            }
    
            this.carregando = true
            try {
                const fornecedorId = this.$store.getters.fornecedor?.fornecedorId || null
                
                // APENAS uma chamada baseada no tipo de componente
                if (this.modalId === 'modal-conversa') {
                    await conversasHub.acessarConversas(this.usuarioId, fornecedorId)
                } else if (this.modalId === 'modal-conversa-enviada') {
                    await conversasHub.acessarConversasEnviadas(this.usuarioId, fornecedorId)
                } else if (this.modalId === 'modal-conversa-todas') {
                    await conversasHub.acessarTodasConversas(this.usuarioId, fornecedorId)
                }
            } catch (error) {
                console.error('Erro ao carregar conversas:', error)
            } finally {
                this.carregando = false
            }
        },

        onConversasCarregadas(novasConversas) {
            this.conversas = this.processarConversas(novasConversas)
            if (typeof this.calcularTotalNaoLidas === 'function') {
                this.calcularTotalNaoLidas()
            }
        },

        onMensagensMarcadasComoLidas(evento) {
            if (this.conversaAtiva && this.conversaAtiva.id === evento.conversaId) {
                this.$set(this.conversaAtiva, 'qtdNaoLidas', 0)
                
                const conversa = this.conversas.find(c => c.id === evento.conversaId)
                if (conversa) {
                    this.$set(conversa, 'qtdNaoLidas', 0)
                }
                
                if (typeof this.calcularTotalNaoLidas === 'function') {
                    this.calcularTotalNaoLidas()
                }
                
                this.$forceUpdate()
            }
        },

        conectarEventosHub() {
            if (this._eventosRegistrados) {
                return
            }
            
            conversasHub.on('NovaConversaRecebida', this.onNovaConversaRecebida)
            
            // Adiciona o evento para atualizar quando receber nova mensagem
            conversasHub.on('NovaMensagemRecebida', this.onNovaMensagemRecebida)
            
            // Registra eventos específicos baseado no tipo
            if (this.modalId === 'modal-conversa') {
                conversasHub.on('ConversasCarregadas', this.onConversasCarregadas)
            } else if (this.modalId === 'modal-conversa-enviada') {
                conversasHub.on('ConversasEnviadasCarregadas', this.onConversasEnviadasCarregadas)
            } else if (this.modalId === 'modal-conversa-todas') {
                conversasHub.on('TodasConversasCarregadas', this.onConversasCarregadas)
            }

            this._eventosRegistrados = true
        },

        desconectarEventosHub() {
            if (!this._eventosRegistrados) return
            
            conversasHub.off('NovaConversaRecebida', this.onNovaConversaRecebida)
            conversasHub.off('NovaMensagemRecebida', this.onNovaMensagemRecebida)
            
            if (this.modalId === 'modal-conversa') {
                conversasHub.off('ConversasCarregadas', this.onConversasCarregadas)
            } else if (this.modalId === 'modal-conversa-enviada') {
                conversasHub.off('ConversasEnviadasCarregadas', this.onConversasEnviadasCarregadas)
            } else if (this.modalId === 'modal-conversa-todas') {
                conversasHub.off('TodasConversasCarregadas', this.onConversasCarregadas)
            }

            this._eventosRegistrados = false
        },

        onNovaMensagemRecebida(dadosMensagem) {
            if (dadosMensagem && dadosMensagem.conversaId) {
                setTimeout(() => {
                    this.carregarConversas()
                }, 500)
            }
        },

        processarConversas(novasConversas) {
            if (!novasConversas || !Array.isArray(novasConversas)) {
                console.error('Dados de conversas inválidos:', novasConversas)
                return []
            }
            
            const conversasOrdenadasMensagens = novasConversas.map(c => {
                const qtdNaoLidas = c.qtdMensagensNaoLidas || c.qtdNaoLidas || 0
                
                return {
                    ...c,
                    id: String(c.id),
                    qtdNaoLidas: qtdNaoLidas,
                    mensagens: Array.isArray(c.mensagens)
                    ? [...c.mensagens].sort((a, b) => new Date(b.dataEnvio) - new Date(a.dataEnvio))
                    : []
                }
            })

            return conversasOrdenadasMensagens.sort((a, b) => {
                const aUltima = a.mensagens[0]?.dataEnvio || a.dataCriacao
                const bUltima = b.mensagens[0]?.dataEnvio || b.dataCriacao
                return new Date(bUltima) - new Date(aUltima)
            })
        }
    },

    computed: {
        modalId() {
            return 'modal-conversa'
        },

        tabelaId() {
            return 'tabela-conversas'
        },

        deveExibirParticipantes() {
            const fornecedorId = this.$store.getters.fornecedor?.fornecedorId
            return !(fornecedorId && fornecedorId !== null && fornecedorId !== undefined && fornecedorId !== '')
        }
    }
}
